export const PENDING_DEALER_REVIEW_PAYMENT_STATUS = 'PendingDealerReview';
export const SALES_CHECK_IN_APPLICATION_NAME = 'Sales Check-In';

// One rule for both the version author and the marker's `source`, which carry the same value.
export const isSalesCheckInName = (value: unknown): boolean =>
    typeof value === 'string' && value.toLowerCase() === SALES_CHECK_IN_APPLICATION_NAME.toLowerCase();

export const SCI_VERSION_COMMENT_LABELS = {
    vehicle: 'Updated vehicle',
    customer: 'Updated customer details',
    trade: 'Updated trade-in'
} as const;

export type SciVersionCommentChangeType = keyof typeof SCI_VERSION_COMMENT_LABELS;
